module.exports = __webpack_public_path__ + "static/media/print-search.f0d0c24f.svg";